import React, { useState } from "react";
import { FaCheckCircle, FaTruck } from "react-icons/fa";

import { HAL_KEY, JNT_KEY, LOGISTICS_DATAS, MIXAY_KEY } from "../../../constants";
import "./DeliveryPicker.css";

// ໂລໂກ້ໃນເຄື່ອງມາກ່ອນ ຂອງ LOGISTICS_DATAS ບາງເຈົ້າເປັນ URL ພາຍນອກທີ່ອາດໂຫຼດບໍ່ຂຶ້ນ
const LOGO_BY_KEY = {
  [HAL_KEY]: "/images/hal.png",
  [JNT_KEY]: "/images/jnt.png",
  [MIXAY_KEY]: LOGISTICS_DATAS?.mixay?.image,
};

function DeliveryPicker({ options, value, onChange }) {
  const [brokenLogos, setBrokenLogos] = useState({});

  return (
    <div className="delivery-picker" role="radiogroup" aria-label="ເລືອກຂົນສົ່ງ">
      {options.map((option) => {
        const isSelected = value === option.value;
        const logo = LOGO_BY_KEY[option.value];
        const showLogo = logo && !brokenLogos[option.value];
        const isDisabled = !!option.disabled;

        return (
          <label
            key={option.value}
            className={`delivery-card${isSelected ? " delivery-card--selected" : ""}${isDisabled ? " delivery-card--disabled" : ""}`}
          >
            <input
              className="delivery-card__input"
              type="radio"
              name="delivery-option"
              value={option.value}
              checked={isSelected}
              disabled={isDisabled}
              onChange={() => onChange(option.value)}
            />
            {/* ວາງຕັ້ງ: ໂລໂກ້ເທິງ ຊື່ລຸ່ມ — ຊື່ຈຶ່ງໄດ້ຄວາມກວ້າງເຕັມຖັນ
                ຖ້າວາງນອນ ຊື່ຈະເຫຼືອແຕ່ຖັນລົບໂລໂກ້ ~80px ເຊິ່ງບໍ່ພໍໃສ່ "J&T Express" */}
            <span className="delivery-card__body">
              <span className={`delivery-card__tile${showLogo ? "" : " delivery-card__tile--icon"}`}>
                {showLogo ? (
                  <img
                    className="delivery-card__logo"
                    src={logo}
                    alt=""
                    onError={() => setBrokenLogos((prev) => ({ ...prev, [option.value]: true }))}
                  />
                ) : (
                  <span className="delivery-card__fallback" aria-hidden="true">
                    <FaTruck />
                  </span>
                )}
              </span>
              <span className="delivery-card__name">{option.label}</span>
            </span>
            {isSelected && (
              <span className="delivery-card__check" aria-hidden="true">
                <FaCheckCircle />
              </span>
            )}
          </label>
        );
      })}
    </div>
  );
}

export default DeliveryPicker;
